import { SavedSearchRedirectPageLoadable } from '#/modules/search/pages/SavedSearchRedirect/SavedSearchRedirectPageLoadable';
import { redirectToSavedSearchRoute } from '#/modules/search/routing/search.routes';
import { userDashboardApiIsomorphicFetchSavedSearch } from '#/modules/userDashboard/api/savedSearch/userDashboardApiIsomorphicFetchSavedSearch';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

export async function loader({
  request,
  context,
  params: { savedSearchId },
}: HorizonAppRouteLoaderArgs<typeof redirectToSavedSearchRoute>) {
  const [savedSearch] = await Promise.all([
    userDashboardApiIsomorphicFetchSavedSearch({ request, context })(
      savedSearchId,
    ),
    SavedSearchRedirectPageLoadable.load(),
  ]);

  return { savedSearch };
}

export default function SavedSearchRedirectHorizonRoute({
  loaderData: { savedSearch },
}: HorizonAppRouteComponentProps<typeof loader>) {
  return <SavedSearchRedirectPageLoadable savedSearch={savedSearch} />;
}
